module.exports = __webpack_public_path__ + "static/media/london.df8e2321.jpg";